export default __webpack_public_path__ + "static/media/lexLogo.96f883e4.png";